// src/Services/LocationService.js
import { ServiceProvider } from "./ServiceProvider";
import apiCall from "../utils/apiInterceptor";

class LocationService {
    static async getAll(page_no = 1, count = 10, search = "") {
        try {
            let url = "";

            // ✅ Use search API if search has value
            if (search && search.trim() !== "") {
                url = `${ServiceProvider.location.search}?search_text=${encodeURIComponent(search)}&page_no=${page_no}&count=${count}`;
            }
            // ✅ Otherwise, use normal getAll API
            else {
                url = `${ServiceProvider.location.getAll}?page_no=${page_no}&count=${count}`;
            }

            const response = await apiCall(url, {
                method: "GET",
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || "Failed to fetch locations");
            }

            return await response.json();
        } catch (error) {
            console.error("Error fetching locations:", error);
            throw new Error(error.message || "Unable to process your request");
        }
    }

    static async create(locationData) {
        try {
            const response = await apiCall(ServiceProvider.location.create, {
                method: "POST",
                body: JSON.stringify({ locations: locationData }),
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || "Failed to create location");
            }

            return await response.json();
        } catch (error) {
            console.error("Error creating location:", error);
            throw new Error(error.message || "Failed to create location");
        }
    }

    static async createSingle(locationData) {
        try {
            const response = await apiCall(ServiceProvider.location.createSingle, {
                method: "POST",
                body: JSON.stringify(locationData),
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || "Failed to create location");
            }

            return await response.json();
        } catch (error) {
            console.error("Error creating single location:", error);
            throw new Error(error.message || "Failed to create location");
        }
    }

    static async bulkCreate(locationData) {
        try {
            const response = await apiCall(ServiceProvider.location.create, {
                method: "POST",
                body: JSON.stringify(locationData),
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || "Failed to bulk create locations");
            }

            return await response.json();
        } catch (error) {
            console.error("Error bulk creating locations:", error);
            throw new Error(error.message || "Failed to create location");
        }
    }

    static async update(id, data) {
        try {
            const response = await apiCall(`${ServiceProvider.location.update}${id}`, {
                method: "POST",
                body: JSON.stringify(data),
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || "Failed to update location");
            }

            return await response.json();
        } catch (error) {
            console.error("Error updating location:", error);
            throw new Error(error.message || "Failed to update location");
        }
    }

    static async getById(id) {
        try {
            const response = await apiCall(`${ServiceProvider.location.getById}${id}`, {
                method: "GET",
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || "Failed to get location");
            }

            return await response.json();
        } catch (error) {
            console.error("Error getting location by ID:", error);
            throw new Error(error.message || "Unable to get location by ID");
        }
    }

    static async getByPartno(partno) {
        try {
            const response = await apiCall(`${ServiceProvider.location.getByPartno}${partno}`, {
                method: "GET",
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || "Failed to get location");
            }

            return await response.json();
        } catch (error) {
            console.error("Error getting location by Part No:", error);
            throw new Error(error.message || "Unable to get location by Part No");
        }
    }

    static async delete(id) {
        try {
            const response = await apiCall(`${ServiceProvider.location.delete}${id}`, {
                method: "DELETE",
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || "Failed to delete location");
            }

            return await response.json();
        } catch (error) {
            console.error("Error deleting location:", error);
            throw new Error(error.message || "Failed to delete location");
        }
    }
}

export default LocationService;